module.exports = __webpack_public_path__ + "media/images/gift/hatena-0ad71c92c5e95d7b807c1f838331deac.png";